const teamKeys = {
  '中信兄弟': 'ctbc-brothers',
  '富邦悍將': 'fubon-guardians',
  '統一7-ELEVEn獅': 'uni-7-eleven-lions',
  '樂天桃猿': 'rakuten-monkeys',
  '味全龍': 'wei-chuan-dragons',
  '台鋼雄鷹': 'tsg-hawks'
}
export const resolvePlayerMap = (data) => {
  let rdata = {
    'ctbc-brothers': {},
    'fubon-guardians': {},
    'uni-7-eleven-lions': {},
    'rakuten-monkeys': {},
    'wei-chuan-dragons': {},
    'tsg-hawks': {}
  }
  for (const d of data) {
    rdata[teamKeys[d.Team]][d.Number] = d.Name
  }
  return rdata
}
export const resolvePlayerTypeMap = (data) => {
  let rdata = {
    'ctbc-brothers': {},
    'fubon-guardians': {},
    'uni-7-eleven-lions': {},
    'rakuten-monkeys': {},
    'wei-chuan-dragons': {},
    'tsg-hawks': {}
  }
  for (const d of data) {
    rdata[teamKeys[d.Team]][d.Number] = d.BP === 'P'? 'pitcher':'batter'
  }
  return rdata
}
export const resolvePlayerPositionMap = (data) => {
  let rdata = {
    'ctbc-brothers': {},
    'fubon-guardians': {},
    'uni-7-eleven-lions': {},
    'rakuten-monkeys': {},
    'wei-chuan-dragons': {},
    'tsg-hawks': {}
  }
  for (const d of data) {
    rdata[teamKeys[d.Team]][d.Number] = d.Pos
  }
  return rdata
}
export const resolvePlayerInfoMap = (data) => {
  let rdata = {
    'ctbc-brothers': {},
    'fubon-guardians': {},
    'uni-7-eleven-lions': {},
    'rakuten-monkeys': {},
    'wei-chuan-dragons': {},
    'tsg-hawks': {}
  }
  for (const d of data) {
    rdata[teamKeys[d.Team]][d.Name] = d.Number
  }
  return rdata
}
export const resolvePlayerLeaderBoardInfoMap = (data) => {
  let rdata = {}
  for (const d of data) {
    rdata[d.ID] = { ...d }
  }
  return rdata
}
export const resolvePlayerIDMap = (data) => {
  let rdata = {
    'ctbc-brothers': {},
    'fubon-guardians': {},
    'uni-7-eleven-lions': {},
    'rakuten-monkeys': {},
    'wei-chuan-dragons': {},
    'tsg-hawks': {}
  }
  for (const d of data) {
    rdata[teamKeys[d.Team]][d.Number] = d.ID
  }
  return rdata
}
export const resolvePlayerAutoCompleteList = (data) => {
  let output = { BatterACOptionMap: [], CatcherACOptionMap: [], PitcherACOptionMap: [] }
  for (const d of data) {
    if (d.Pos === 'P') {
      output.PitcherACOptionMap.push({label: d.Name, team: d.Team, number: d.Number, id: d.ID})
    } else if (d.Pos === 'C') {
      output.BatterACOptionMap.push({label: d.Name, team: d.Team, number: d.Number, id: d.ID})
      output.CatcherACOptionMap.push({label: d.Name, team: d.Team, number: d.Number, id: d.ID})
    } else {
      output.BatterACOptionMap.push({label: d.Name, team: d.Team, number: d.Number, id: d.ID})
    }
  }
  return output
}